export default "__VITE_ASSET__KhNGKgWb__"